/* Cookie-банер (T-E7-09, A-052): як на live - нативний Shopify Customer Privacy банер (#shopify-pc__banner /
   #shopify-pc__prefs). Тут: 1) переклад англ. рядків за LystiaCookieMap (дослівно з live-секції lystia-cookie-uk),
   2) body.has-cookie + --cookie-h, щоб FAB піднімався над банером. Згоду/гейтинг пікселів веде Shopify. */
(function () {
  if (window.__lystiaCookie) return;
  window.__lystiaCookie = true;
  if (window.Shopify && Shopify.designMode) return;

  var MAP = {};
  try { MAP = JSON.parse(document.getElementById('LystiaCookieMap').textContent); } catch (e) { return; }
  var has = Object.prototype.hasOwnProperty;
  function norm(s) { return s.replace(/\s+/g, ' ').trim(); }

  function translate(root) {
    root.setAttribute('lang', 'uk');
    var labelled = root.querySelectorAll('[aria-label]');
    for (var j = 0; j < labelled.length; j++) {
      var al = norm(labelled[j].getAttribute('aria-label') || '');
      if (has.call(MAP, al)) labelled[j].setAttribute('aria-label', MAP[al]);
    }
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, nodes = [];
    while ((n = walker.nextNode())) {
      var tag = n.parentNode && n.parentNode.nodeName;
      if (tag !== 'STYLE' && tag !== 'SCRIPT') nodes.push(n);
    }
    nodes.forEach(function (node) {
      var inner = node.nodeValue.trim(), key = norm(inner);
      if (key && has.call(MAP, key)) node.nodeValue = node.nodeValue.replace(inner, MAP[key]);
    });
  }

  var ro = null, watched = null;
  function lift() {
    var b = document.getElementById('shopify-pc__banner');
    var on = !!(b && b.offsetHeight > 0 && getComputedStyle(b).visibility !== 'hidden');
    if (on) {
      document.body.style.setProperty('--cookie-h', b.offsetHeight + 'px');
      document.body.classList.add('has-cookie');
      if (window.ResizeObserver && watched !== b) {
        if (ro) ro.disconnect();
        ro = new ResizeObserver(lift); ro.observe(b); watched = b;
      }
    } else {
      document.body.classList.remove('has-cookie');
      document.body.style.removeProperty('--cookie-h');
      if (ro) { ro.disconnect(); ro = null; watched = null; }
    }
  }

  var raf = 0;
  function run() {
    raf = 0;
    var roots = document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs');
    for (var i = 0; i < roots.length; i++) translate(roots[i]);
    lift();
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(run); }

  function init() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[id^="shopify-pc__"]')) { setTimeout(run, 60); setTimeout(run, 400); }
    }, true);
  }
  if (document.body) init(); else document.addEventListener('DOMContentLoaded', init);
})();
